/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'search': {
    width: 16,
    height: 16,
    viewBox: '0 0 15.95 15.95',
    data: '<g data-name="图层 2"><g data-name="图层 1" _fill="#c4c4c4"><path pid="0" d="M6.33 12.66a6.33 6.33 0 114.48-10.81 6.33 6.33 0 01-4.48 10.81zM6.33 1a5.33 5.33 0 103.77 1.56A5.32 5.32 0 006.33 1z"/><path pid="1" d="M15.45 16a.5.5 0 01-.35-.15l-5-5a.5.5 0 01.71-.71l5 5a.5.5 0 01-.35.85z"/></g></g>'
  }
})
